module.exports = __webpack_public_path__ + "img/W-G33.3a06b1e6.jpg";